module.exports = __webpack_public_path__ + "img/promotion-nothing.d683854b.png";